import React from 'react';
import { useSelector } from 'react-redux';
import { Navigate, useNavigate } from 'react-router-dom';

const NotFound = () => {
  const navigate = useNavigate();
  const { isAuthenticated } = useSelector((state) => state.auth);
  if (!isAuthenticated) {
    return <Navigate to='/signin' replace />;
  }
  return (
    <div className='flex flex-col items-center justify-center min-h-screen bg-gray-100'>
      <h1 className='mb-4 text-6xl font-bold text-gray-800'>404</h1>
      <p className='mb-8 text-xl text-gray-600'>Page Not Found</p>
      <p className='mb-8 text-gray-500'>
        The page you're looking for doesn't exist or has been moved.
      </p>
      <button
        onClick={() => navigate('/signin')}
        className='px-6 py-3 text-white transition-colors bg-blue-600 rounded-md hover:bg-blue-700'
      >
        Go Back
      </button>
    </div>
  );
};

export default NotFound;
